import GlobalContext from "context/GlobalContext";
import React from "react";
import Authmiddleware from "routes/Authmiddleware";

const App = () => {
  return (
    <GlobalContext>
      <Authmiddleware />
    </GlobalContext>
  );
};

export default App;
